import { memo, useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { SingleUploadedDateFilter } from '~/components/Filters/DateFilter/SingleUploadedDateFilter';
import { FilterTrigger } from '~/components/Filters/SingleFilters/FilterTrigger';
import { type SingleFilterProps } from '~/components/Filters/types';
import { baseFiltersOptions } from '~/components/FiltersMenu/types';
import { useFilterParams } from '~/hooks/filters/useFilterParams';
import { removeFilterAction } from '~/store/filters/actions';
import { type SelectedFilter } from '~/store/filters/types';

export type UploadedDateFilterTriggerProps = SingleFilterProps;

export const UploadedDateFilterTrigger = memo(
  ({ onApplyClick, onRemoveClick, onOpenChange }: UploadedDateFilterTriggerProps) => {
    const dispatch = useDispatch();
    const { uploadedDateParam } = useFilterParams();

    const content = useMemo(() => <SingleUploadedDateFilter onApplyClick={onApplyClick} />, [onApplyClick]);

    const removeFilter = useCallback(async () => {
      const filter: SelectedFilter = { type: 'dateUploaded' };
      dispatch(removeFilterAction({ filter: { type: 'dateUploaded' } }));
      onRemoveClick?.([filter]);
    }, [dispatch, onRemoveClick]);

    return (
      <FilterTrigger
        count={uploadedDateParam?.start || uploadedDateParam?.end ? 1 : 0}
        filterContent={content}
        title={baseFiltersOptions['dateUploaded'].label}
        onRemoveClick={removeFilter}
        Icon={baseFiltersOptions['dateUploaded'].icon}
        onOpenChange={onOpenChange}
      />
    );
  },
);

UploadedDateFilterTrigger.displayName = 'UploadedDateFilterTrigger';
